import React, { useState, useMemo } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TableSortLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import { Add } from "@mui/icons-material"; // add-child icon
import { visuallyHidden } from "@mui/utils";
import axios from "axios";
import SuggestionInput from "../suggestionInput/suggestionInput"; // same one from parent
import { useDispatch, useSelector } from 'react-redux';
 
const Order = "asc";

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  { id: "action", numeric: false, disablePadding: true, label: "" }, // 🔹 Added action col
  { id: "Srn", numeric: false, disablePadding: true, label: "Srn" },
  { id: "name", numeric: true, disablePadding: false, label: "Parent Name" },
  { id: "ParentMobile", numeric: true, disablePadding: false, label: "Parent Mobile" },
  { id: "OTP", numeric: true, disablePadding: false, label: "OTP" },
  { id: "Children", numeric: true, disablePadding: false, label: "Student Roll" },
  { id: "Status", numeric: true, disablePadding: false, label: "Status" },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => onRequestSort(event, property);

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.id !== "action" ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function AccessibleTableMobileApp({ rows, suggestions, onChildAdded }) {
  const [order, setOrder] = useState(Order);
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const url =  useSelector((state) => state.Api);

  const [openModal, setOpenModal] = useState(false);
  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedChildren, setSelectedChildren] = useState([]);
    const dispatch = useDispatch();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const visibleRows = useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [rows, order, orderBy, page, rowsPerPage]
  );

  const handleAddChildClick = (row) => {
    setSelectedParent(row);
    setSelectedChildren([]);
    setOpenModal(true);
  };
 
  const handleSaveChild = async () => {
    try {
      console.log(selectedChildren, selectedParent);
      await axios.post(
        url.assignChildren,
        {
          Parent: selectedParent.Srn,
          Students: selectedChildren,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("User_Data")).token}`,
          },
        }
      );
      setOpenModal(false);
      if (onChildAdded) onChildAdded(); // refresh parent list
    } catch (err) {
      console.error("Error adding child:", err.response?.data || err.message);
    }
  };
 
  const handleDeleteChildClick = (child, id) => {
  const confirmDelete = window.confirm(`ایا تاسو ډاډه یاست چې حذف کړئ؟ [${child.Reg_Student}]`);
  if (confirmDelete) {
    deleteChild(child, id); // call API here
  }
};

const deleteChild = async (child, id) => {
   try {
      console.log(child, id);
      await axios.post(
        url.removeChild,
        {
          parentSrn: child?.Parent_Srn,
          student: child?.Reg_Student,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("User_Data")).token}`,
          },
        }
      );
      setOpenModal(false);
      if (onChildAdded) onChildAdded(); // refresh parent list
    } catch (err) {
      console.error("Error adding child:", err.response?.data || err.message);
    }
};

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} size="small">
            <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
            <TableBody>
              {visibleRows.map((row, index) => (
                <TableRow key={row.Srn} hover>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>{row.Srn}</TableCell>
                  <TableCell>{row.Parent_Name}</TableCell>
                  <TableCell>{row.Parent_Mobile}</TableCell>
                  <TableCell>{row.Otp}</TableCell>
                  <TableCell>
                    {row.children &&
                      row.children.map((child, idx) => (
                        <IconButton onClick={() => handleDeleteChildClick(child, idx)} sx={{ fontSize: "14px", padding: "0px 4px" }} key={idx}>{child.Reg_Student}, </IconButton>
                      ))}
                      <IconButton onClick={() => handleAddChildClick(row)}>
                      <Add />
                    </IconButton>
                  </TableCell>
                  <TableCell>{row.approved}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[20, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>

      {/* 🔹 Add Child Popup */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)} PaperProps={{style: {minHeight: "350px"},}} maxWidth="sm" fullWidth>
        <DialogTitle>Select Children for Parent</DialogTitle>
        <DialogContent>
          <SuggestionInput
            handleInputChange={(e) => {
              const val = e.target.value;
              if (!selectedChildren.includes(val)) {
                setSelectedChildren((prev) => [...prev, val]);
              }
            }}
            Suggestions={suggestions}
            placeholder="Roll No / Name"
            name="childRoll"
          />
          <Box mt={2}>
            {selectedChildren.map((child, idx) => (
              <div
                key={idx}
                style={{ cursor: "pointer", padding: "5px", borderBottom: "1px solid #ddd" }}
                onClick={() =>
                  setSelectedChildren((prev) => prev.filter((_, i) => i !== idx))
                }
              >
                {child}
              </div>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveChild}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
